import apiCreator from './util/ApiCreator';
const api = apiCreator('/api-public/dealer-portal');

export default {
    get () {
        return api.get('/');
    },
}
